import Footer from "../Homepages/Footer";
import {BsArrowLeft} from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import images from "../Homepages/homeConfig.js";
import { affirms } from "../../reducers/userReducer";
import { useDispatch } from "react-redux";

export default function Prosperity() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {frame1, frame2, frame3, frame4, frame5, frame6} = images.images
  const frames = [frame1, frame2, frame3, frame4, frame5, frame6];
  return (
    <div className="container px-4 mb-5">
      <div className="heading mb-3 mt-4">
        <BsArrowLeft
          size="30px"
          style={{ cursor: "pointer" }}
          onClick={() => {
            navigate("/affirmIntro");
          }}
        />
        <h3 className="text-center no-wrap">My Affirmations</h3>
      </div>
      <div>
        <h1>Prosperity</h1>
        <h6>6 affirmations</h6>
        <div className="imgF align-items-center justify-content-center">
          {frames.map((frame, index)=>{
            return (
              <img src={frame} key={index} alt="" onClick={()=>{
                dispatch(affirms(index + 1))
                navigate('/affirm/prosperity/details')
              }}/>
            )
          })}
        </div>
      </div>
      <Footer />
    </div>
  );
}
